<template>
    <div class="modal verify-password-modal"
         :class="{ 'is-active': isShown }"
    >
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-card">

            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ title }}
                </p>
                <button
                    class="delete"
                    aria-label="close"
                    @click="closeModal"
                ></button>
            </header>

            <section class="modal-card-body">
                {{ text }}
            </section>

            <footer class="modal-card-foot">
                <button
                    class="button is-danger"
                    @click="confirmToggleIsPublic"
                >
                    {{ trans.confirm }}
                </button>
                <button
                    class="button is-outlined"
                    @click="closeModal"
                >
                    {{ trans.cancel }}
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";

export default {
    name: "BaseFileToggleIsPublicModal",
    computed: {
        ...mapState('fileManagement', {
            isShown: 'fileSetIsPublicModalIsShown',
            trans: 'trans',
        }),
        ...mapGetters('fileManagement', [
            'toggleIsPublicFile',
        ]),
        title() {
            return this.toggleIsPublicFile.is_public
                ? this.trans.toggle_is_public_modal.set_not_public.title
                : this.trans.toggle_is_public_modal.set_is_public.title;
        },
        text() {
            return this.toggleIsPublicFile.is_public
                ? this.trans.toggle_is_public_modal.set_not_public.text
                : this.trans.toggle_is_public_modal.set_is_public.text;
        }
    },
    methods: {
        ...mapActions('fileManagement', {
            closeModal: 'hideFileSetIsPublicModal',
        }),
        ...mapActions('fileManagement', [
            'toggleIsPublic',
        ]),
        confirmToggleIsPublic() {
            this.toggleIsPublic(this.toggleIsPublicFile);
            this.closeModal();
        },
    },
}
</script>

<style scoped>
.modal-card {
    max-width: 500px;
    margin-top: 200px;
}

.modal-card-foot {
    padding-bottom: 20px;
}

.modal-card-body {
    word-break: break-word;
}
</style>